import 'css-chunksrc/client/scenes/projectExpenseCreation/form/expenseTypeSelect/styles.scss';export default {
  "root": "_root_uxnou_1",
  "listRoot": "_listRoot_uxnou_5",
  "list": "_list_uxnou_5",
  "icon": "_icon_uxnou_29",
  "input": "_input_uxnou_38",
  "opened": "_opened_uxnou_56",
  "option": "_option_uxnou_66",
  "selected": "_selected_uxnou_71"
};